import {
  CustomerAddressBlock,
  formatAmount,
  ASUInvoiceHeader,
  InvoiceInfoBlock,
  InvoiceItemsTable,
  InvoiceLayout,
  OrderDetailBatchReturnType,
  ASUInvoiceFooter,
} from './common';

const SGASUGSTInvoice = ({ order }: { order: OrderDetailBatchReturnType }) => {
  const subTotal = order.payAmountActualCurrency || 0;
  const actualCurrencyRate = order.orderItems[0]?.actualCurrencyRate ?? 1;
  const integrationDeduction = order.useIntegration
    ? Math.round(order.useIntegration * actualCurrencyRate)
    : 0;
  const gstAmount = order.totalTaxAmount ?? 0;
  const summaryRows = [
    order.freightAmountActualCurrency
      ? {
          label: 'Freight :',
          value: formatAmount(order.freightAmountActualCurrency),
        }
      : null,
    order.promotionAmountActualCurrency
      ? {
          label: 'Discount :',
          value: `-${formatAmount(order.promotionAmountActualCurrency)}`,
        }
      : null,
    integrationDeduction
      ? {
          label: 'Points Deduction :',
          value: `-${formatAmount(integrationDeduction)}`,
        }
      : null,
    {
      label: 'Total amount payable including GST :',
      value: formatAmount(subTotal),
    },
    {
      label: 'Total amount excluding GST :',
      value: formatAmount(subTotal - gstAmount),
    },
    {
      label: 'Total GST 9% :',
      value: formatAmount(gstAmount),
    },
  ].filter((row): row is { label: string; value: string } => Boolean(row));

  return (
    <InvoiceLayout>
      <ASUInvoiceHeader title="Tax Invoice" />

      <section className="mb-[30px] flex items-start justify-between gap-6">
        <CustomerAddressBlock order={order} />
        <InvoiceInfoBlock order={order} invoiceNoLabel="Tax Invoice No :" />
      </section>

      <InvoiceItemsTable order={order} />

      <section className="ml-auto mr-[6px] w-[430px] text-xs mb-[30px]">
        {summaryRows.map((row) => (
          <div
            className="grid grid-cols-[1fr_112px] gap-x-8 mb-2 last:mb-0"
            key={row.label}
          >
            <span className="text-right whitespace-nowrap">{row.label}</span>
            <span className="text-right tabular-nums">{row.value}</span>
          </div>
        ))}
      </section>

      <p className="text-sm font-bold text-center mb-[34px]">
        ITEMS SOLD CANNOT BE RETURNED OR EXCHANGED
      </p>

      <section className="text-xs leading-[1.8]">
        <p className="font-bold mb-[22px]">
          Cheque payment to &quot;ASU Company Pte. Ltd.&quot;
        </p>

        <ASUInvoiceFooter />
      </section>
    </InvoiceLayout>
  );
};

export default SGASUGSTInvoice;
